// src/PublicUser/components/BlogFooter.jsx
import React from 'react';
import '../../css/BlogFooter.css';

const BlogFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="ts-blog-footer">
      <div className="ts-blog-footer-container">
        {/* Main Footer Content */}
        <div className="ts-blog-footer-grid">
          
          {/* Brand Section */}
          <div className="ts-blog-footer-section ts-brand-section">
            <div className="ts-blog-footer-logo">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path d="M16 4L4 10L16 16L28 10L16 4Z" stroke="#00D4FF" strokeWidth="2" fill="none"/>
                <path d="M4 16L16 22L28 16" stroke="#00D4FF" strokeWidth="2" fill="none"/>
                <path d="M4 22L16 28L28 22" stroke="#00D4FF" strokeWidth="2" fill="none"/>
              </svg>
              <span>TechShara <span className="ts-footer-blog-text">Blog</span></span>
            </div>
            <p className="ts-blog-footer-description">
              Your go-to source for in-depth tech tutorials, industry insights, 
              and practical development guides from experienced engineers.
            </p>
            <div className="ts-blog-footer-social">
              <a href="https://www.instagram.com/akashgc.21/" className="ts-social-icon" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M17 2H7C4.23858 2 2 4.23858 2 7V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V7C22 4.23858 19.7614 2 17 2Z" stroke="currentColor" strokeWidth="2"/>
                  <path d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z" stroke="currentColor" strokeWidth="2"/>
                  <path d="M17.5 6.5H17.51" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </a>
              <a href="https://www.youtube.com/@akashgc21" className="ts-social-icon" aria-label="YouTube" target="_blank" rel="noopener noreferrer">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M22.54 6.42C22.4212 5.94541 22.1792 5.51057 21.8387 5.15941C21.4982 4.80824 21.0708 4.55318 20.6 4.42C18.88 4 12 4 12 4C12 4 5.12 4 3.4 4.46C2.92923 4.59318 2.50176 4.84824 2.16128 5.19941C1.8208 5.55057 1.57879 5.98541 1.46 6.46C1.14523 8.20556 0.991235 9.97631 1 11.75C0.990765 13.5237 1.14477 15.2944 1.46 17.04C1.5908 17.5065 1.83856 17.9317 2.17815 18.2761C2.51774 18.6205 2.93609 18.8749 3.4 19.01C5.12 19.47 12 19.47 12 19.47C12 19.47 18.88 19.47 20.6 19.01C21.0708 18.8768 21.4982 18.6218 21.8387 18.2706C22.1792 17.9194 22.4212 17.4846 22.54 17.01C22.8524 15.2644 23.006 13.4937 23 11.72C23.0092 9.94631 22.8552 8.17556 22.54 6.42Z" stroke="currentColor" strokeWidth="2"/>
                  <path d="M9.75 15.02L15.5 11.75L9.75 8.48V15.02Z" stroke="currentColor" strokeWidth="2" fill="currentColor"/>
                </svg>
              </a>
              <a href="https://www.linkedin.com/in/akashgc/" className="ts-social-icon" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </a>
              <a href="https://www.tiktok.com/@akashgc.54" className="ts-social-icon" aria-label="TikTok" target="_blank" rel="noopener noreferrer">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" fill="currentColor"/>
                </svg>
              </a>
              <a href="https://www.linkedin.com/in/akashgc/" className="ts-social-icon" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M4 4H20C20.5523 4 21 4.44772 21 5V19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19V5C3 4.44772 3.44772 4 4 4Z" stroke="currentColor" strokeWidth="2"/>
                  <path d="M8 11V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M8 8V8.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M12 16V11" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M16 16V13C16 11.8954 15.1046 11 14 11C13.4477 11 13 11.4477 13 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="ts-blog-footer-section">
            <h4 className="ts-footer-title">Explore</h4>
            <ul className="ts-footer-links">
              <li><a href="/blog">Latest Articles</a></li>
              <li><a href="/blog/popular">Popular Posts</a></li>
              <li><a href="/learning-zone">Tutorials</a></li>
              <li><a href="/learning-zone/guides">Guides</a></li>
              <li><a href="/tools">Tools & Resources</a></li>
            </ul>
          </div>

          {/* Categories */}
          <div className="ts-blog-footer-section">
            <h4 className="ts-footer-title">Resources</h4>
            <ul className="ts-footer-links">
              <li><a href="/tools">Developer Tools</a></li>
              <li><a href="/language-translator">MultiLanguage Translator</a></li>
              <li><a href="/learning-zone">Learning Zone</a></li>
              <li><a href="/blog/case-studies">Case Studies</a></li>
              <li><a href="/blog/api-docs">API Documentation</a></li>
              <li><a href="/blog/opensource">Open Source Projects</a></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="ts-blog-footer-section">
            <h4 className="ts-footer-title">Stay Updated</h4>
            <p className="ts-newsletter-text">
              Get the latest tech insights delivered to your inbox weekly.
            </p>
            <form className="ts-newsletter-form" onSubmit={(e) => e.preventDefault()}>
              <input 
                type="email" 
                placeholder="Your email address" 
                className="ts-newsletter-input"
              />
              <button type="submit" className="ts-newsletter-btn">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </button>
            </form>
            <div className="ts-footer-stats">
              <div className="ts-stat-item">
                <span className="ts-stat-number">50+</span>
                <span className="ts-stat-label">Articles</span>
              </div>
              <div className="ts-stat-item">
                <span className="ts-stat-number">10K+</span>
                <span className="ts-stat-label">Readers</span>
              </div>
              <div className="ts-stat-item">
                <span className="ts-stat-number">15+</span>
                <span className="ts-stat-label">Topics</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="ts-blog-footer-bottom">
          <div className="ts-footer-copyright">
            <p>© {currentYear} TechShara. All rights reserved.</p>
          </div>
          <div className="ts-footer-legal">
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/terms-of-service">Terms of Service</a>
            <a href="/cookie-policy">Cookie Policy</a>
            <a href="/about">About Us</a>
            <a href="/contact">Contact</a>
          </div>
          <div className="ts-footer-back-to-top">
            <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M12 5V19M12 5L5 12M12 5L19 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              Back to Top
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default BlogFooter;